module.exports = __webpack_public_path__ + "img/bmg9.10fb3555.png";